import axios from 'axios';
import { defineStore } from 'pinia';
import { useStoreRoot } from '../abstract/root';
import { useStoreSsPlayer } from '../softswiss/player';
import { useStoreStag } from './stag';

const PIXEL_URL = 'https://pixel-us.7-ubi.com/pixel';

const mapEventToken = {
  visit: 'dn2juq',
  other: 'dqgmaj',
  bet: '4ykza8',
  deposit: '49yna2',
  ftd: 'dw3vcw',
  regfinished: 'dg1eh2',
  // regstarted: 'rjquq8',
  login: '4ekva7',
} as const;

interface IUbidexSendOptions {
  event: keyof typeof mapEventToken;
  userId?: number;
  transactionId?: string | number;
  currency?: string;
  amount?: string | number;
  stag?: string | number;
}

export const useStoreUbidex = defineStore('ubidex', {
  state: () => ({
    visited: false,
  }),
  actions: {
    async sendEvent(options: IUbidexSendOptions) {
      if (import.meta.server || (this.visited && options.event === 'visit')) {
        return;
      }

      const storeSsPlayer = useStoreSsPlayer();
      const userId = options.userId || storeSsPlayer.playerInfo.id;
      const stag = options.stag || useStoreStag().currentPureStag;
      let currency = options.currency || useStoreRoot().userCurrency;
      if (currency === 'DOG') {
        currency = 'DOGE';
      }

      const searchParams = new URLSearchParams();
      searchParams.append('auth', mapEventToken[options.event]);
      searchParams.append('event', options.event);

      if (userId) {
        searchParams.append('uid', userId.toString());
      }

      if (options.transactionId) {
        searchParams.append('tid', options.transactionId?.toString());
      }

      searchParams.append('cur', currency);

      if (options.amount) {
        searchParams.append('amount', options.amount.toString());
      }

      searchParams.append('affid', stag.toString());

      searchParams.append('site', window.location.host);

      searchParams.append('ln', navigator.language);

      try {
        await axios.get(`${PIXEL_URL}?${searchParams.toString()}`);
      } catch (e) {
        console.error(e);
      }

      if (options.event === 'visit') {
        this.visited = true;
      }
    },
    async sendAdditionalUserInfo() {
      if (import.meta.server) {
        return;
      }

      const storeSsPlayer = useStoreSsPlayer();
      const userId = storeSsPlayer.playerInfo.id;
      const stag = useStoreStag().currentPureStag;

      if (!userId) {
        return;
      }

      const searchParams = new URLSearchParams();
      searchParams.append('userID', userId.toString());
      searchParams.append('stag', stag.toString());
      searchParams.append('site', window.location.host);

      searchParams.append('ln', navigator.language);

      try {
        await axios.get(`/crm-backend/open-deposit?${searchParams.toString()}`);
      } catch (e) {
        console.error(e);
      }
    },
  },
});
